import { observer } from 'mobx-react-lite'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { Card } from '@/components/Card'
import { InfoGatheringCardContent } from '@/features/jobs/details/components/InfoGatheringCard'

export interface InfoGatheringCardContainerProps {
  vm: JobDetailsViewModel
}

export const InfoGatheringCardContainer = observer(
  function InfoGatheringCardContainer({ vm }: InfoGatheringCardContainerProps) {
    const infoGatheringVm = vm.capturedInformationVm.infoGatheringCardVm
    return (
      <Card>
        <InfoGatheringCardContent
          title={infoGatheringVm.title}
          description={infoGatheringVm.description}
          isCompletionOpen={infoGatheringVm.isCompletionOpen}
          canCompleteInfoGathering={infoGatheringVm.canCompleteInfoGathering}
          onComplete={infoGatheringVm.completeInfoGatheringDialogVm.modal.show}
        />
      </Card>
    )
  },
)
